import { call, select, put, takeLatest, all } from "redux-saga/effects";
import api from "../../Environment";
import {
  ADD_BANK_ACCOUNT_START,
  GET_BANK_ACCOUNT_START,
  MAKE_DEFAULT_BANK_ACCOUNT_START,
  DELETE_BANK_ACCOUNT_START,
  FETCH_SINGLE_BANK_ACCOUNT_START,
} from "../actions/ActionConstant";
import { createNotification } from "react-redux-notify";
import {
  getSuccessNotificationMessage,
  getErrorNotificationMessage,
} from "../../components/helper/NotificationMessage";
import {
  addBankAccountSuccess,
  addBankAccountFailure,
  getBankAccountSuccess,
  getBankAccountFailure,
  getBankAccountStart,
  makeDefaultBankAccountSuccess,
  makeDefaultBankAccountFailure,
  deleteBankAccountSuccess,
  deleteBankAccountFailure,
  fetchSingleBankAccountSuccess,
  fetchSingleBankAccountFailure,
} from '../actions/BankAccountAction';
import { transferToBankSuccess } from '../actions/BankAccountAction';
import { transferToBankFailed } from '../actions/BankAccountAction';
import { TRANSFER_TO_BANK_START, MASSPAY_LOAD_START } from '../actions/ActionConstant';
import { fetchWalletHistoryStart } from '../actions/WalletAction';
import { fetchWalletDetailsStart } from '../actions/WalletAction';
import { fetchWithDrawalsStart } from '../actions/WithDrawAction';
import { initiatePayoutSuccess } from '../actions/PayoutAction';
import { initiatePayoutFailure } from '../actions/PayoutAction';
import { masspayLoadStart } from '../actions/BankAccountAction';
import masspayService from '../../helpers/services/payment/masspay.service'
import { showErrorComponent } from "../actions/ComponentAction";

function* addBankAccountAPI() {
  try { 
    const inputData = yield select((state) => state.bankAccount.addBankAccountInput.inputData);
    const response = yield api.postAuthMethod('masspay_bank_add', inputData);

    if (response.data.success) {
      yield put(addBankAccountSuccess(response.data));
      const notificationMessage = getSuccessNotificationMessage(
        response.data.message
      );
      yield put(createNotification(notificationMessage));
      yield put(getBankAccountStart());
    } else {
      yield put(addBankAccountFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(addBankAccountFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* getBankAccountAPI() {
  try {
    const response = yield api.postAuthMethod('masspay_bank_list');

    if (response.data.success) {
      yield put(getBankAccountSuccess(response.data.data));
    } else {
      yield put(getBankAccountFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(getBankAccountFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* makeDefaultBankAccountAPI() {
  try {
    const inputData = yield select(
      (state) => state.bankAccount.makeDefault.inputData
    );
    const response = yield api.postMethod(
      "billing_accounts_default",
      inputData
    );

    if (response.data.success) {
      yield put(makeDefaultBankAccountSuccess(response.data));
      yield put(getBankAccountStart());
      const notificationMessage = getSuccessNotificationMessage(
        response.data.message
      );
      yield put(createNotification(notificationMessage));
    } else {
      yield put(makeDefaultBankAccountFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(makeDefaultBankAccountFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* deleteAccountBankAccountAPI() {
  try {
    const inputData = yield select((state) => state.bankAccount.deleteAccount.inputData);
    const response = yield api.postAuthMethod('masspay_bank_delete', inputData);

    if (response.data.success) {
      yield put(deleteBankAccountSuccess(response.data));

      const notificationMessage = getSuccessNotificationMessage(
        response.data.message
      );
      yield put(createNotification(notificationMessage));
      yield put(getBankAccountStart());
    } else {
      yield put(deleteBankAccountFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(deleteBankAccountFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* fetchSingleBankAccountAPI() {
  try {
    const inputData = yield select(
      (state) => state.bankAccount.singleAccount.inputData
    );
    const response = yield api.postMethod("users_accounts_save", inputData);

    if (response.data.success) {
      yield put(fetchSingleBankAccountSuccess(response.data));
      yield put(getBankAccountStart());
      const notificationMessage = getSuccessNotificationMessage(
        response.data.message
      );
      yield put(createNotification(notificationMessage));
    } else {
      yield put(fetchSingleBankAccountFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(fetchSingleBankAccountFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* initialiseMasspayLoadAPI(){
  try{
    const payout = yield select((state) => state.payoutModel.payout);

    yield masspayService.setupMasspayUser();
    const response = yield api.postAuthMethod('masspay/initiate', {amount: payout.amount});

    if(response.data.success){
      yield put(initiatePayoutSuccess(response.data.data))
      yield put(masspayLoadStart());
    }
    else{
      yield put(initiatePayoutFailure(response.data.error));
        const notificationMessage = getErrorNotificationMessage(
          response.data.error
        );
        yield put(createNotification(notificationMessage));
        yield put(transferToBankFailed(response.data.error));
      }
  }
  catch(error){
    yield put(initiatePayoutFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    yield put(transferToBankFailed(error));
    const notificationMessage = getErrorNotificationMessage(error.response.data.errors||error.message);
    yield put(createNotification(notificationMessage));
  }
}


function* bankTransferAPI() {
  try {
    try {
      const inputData = yield select((state) => state.bankAccount.bankTransfer.inputData);
      const authentication = yield select((state) => state.payoutModel.authentication.data);
      const response = yield api.postAuthMethod('masspay_bank_transfer_wallet', inputData, {headers:{Authorization: `Bearer ${authentication.access_token}`}} );      

      if (response.data.success) {
        yield put(transferToBankSuccess(response.data));
        yield put(getBankAccountStart());
        yield put(fetchWalletHistoryStart());
        yield put(fetchWithDrawalsStart());
        yield put(fetchWalletDetailsStart());
        const notificationMessage = getSuccessNotificationMessage(
          response.data.message
        );
        yield put(createNotification(notificationMessage));
      } else {
        yield put(transferToBankFailed(response.data.error));
        const notificationMessage = getErrorNotificationMessage(
          response.data.error
        );
        yield put(createNotification(notificationMessage));
      }
    } catch (error) {
      yield put(transferToBankFailed(error));
      if (error.response.status == 401) {
        const notificationMessage = getErrorNotificationMessage(
          "Authentication Error : Please sign out and sign in to retry"
        );
        yield put(createNotification(notificationMessage));
      } else {
        const notificationMessage = getErrorNotificationMessage(error.message);
        yield put(createNotification(notificationMessage));
      }
    }
  } catch (error) {
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
  }
}

export default function* pageSaga() {
  yield all([yield takeLatest(ADD_BANK_ACCOUNT_START, addBankAccountAPI)]);
  yield all([yield takeLatest(GET_BANK_ACCOUNT_START, getBankAccountAPI)]);
  yield all([yield takeLatest(MAKE_DEFAULT_BANK_ACCOUNT_START, makeDefaultBankAccountAPI)]);
  yield all([yield takeLatest(DELETE_BANK_ACCOUNT_START, deleteAccountBankAccountAPI)]);
  yield all([yield takeLatest(FETCH_SINGLE_BANK_ACCOUNT_START, fetchSingleBankAccountAPI)]);
  yield all([yield takeLatest(TRANSFER_TO_BANK_START, initialiseMasspayLoadAPI)]);
  yield all([yield takeLatest(MASSPAY_LOAD_START, bankTransferAPI)])
}
